export default {
  carritoTotal(state) {
    return state.total;
  },
  cantidadItems(state) {
    return state.cantItem;
  }

}
